import { createFileRoute, notFound } from "@tanstack/react-router";
import { procedureIdSchema } from "../lib/workIds";
import { ProcedureDetailScreen } from "../screens/ProcedureDetailScreen";

export const Route = createFileRoute("/_app/procedures/$procedureId")({
  params: {
    parse: (params): { procedureId: string } => {
      const parsed = procedureIdSchema.safeParse(params.procedureId);
      if (!parsed.success) throw notFound();
      return { procedureId: parsed.data };
    },
  },
  component: ProcedureDetailRoute,
});

function ProcedureDetailRoute() {
  const { procedureId } = Route.useParams();
  return <ProcedureDetailScreen procedureId={procedureId} />;
}
